import { getUserRoleMapping } from "../utils/api"
import { getUserEmail } from "../utils/auth"

export type OptType = {
  label: string | null
  value: string | null
} | null

type Condition = {
  fact: string
  operator: string
  value: string[]
}

type Rule = {
  any: Condition[]
}

export type RuleData = {
  ruleName: string
  rule: string
  operators: string[]
  operatorRule: string
  status: boolean
  exclusiveRule: boolean
}

export const deconstructRule = (assignmentRule: string) => {
  let rule = assignmentRule
  let parsedRule = rule && JSON.parse(rule)
  let rules = parsedRule?.conditions?.any || parsedRule?.conditions?.all || []
  const operator = parsedRule?.conditions?.any
    ? { label: "or", value: "1" }
    : parsedRule?.conditions?.all
    ? { label: "and", value: "0" }
    : null
  let stores: OptType[] = []
  let taskTypes: OptType[] = []
  let storeConditionOperator: OptType = null
  let taskTypeConditionOperator: OptType = null
  rules &&
    rules.map((conditions: Rule) => {
      conditions &&
        conditions.any &&
        Array.isArray(conditions.any) &&
        conditions.any.map((conditionList: Condition) => {
          if (conditionList.fact === "store_id") {
            for (let val of conditionList.value) {
              stores.push({ label: val, value: val })
            }
            storeConditionOperator =
              conditionList.operator && conditionList.operator === "in"
                ? { label: "=", value: "0" }
                : { label: "!=", value: "1" }
          } else if (conditionList.fact === "task_type") {
            for (let val of conditionList.value) {
              taskTypes.push({ label: val, value: val })
            }
            taskTypeConditionOperator =
              conditionList.operator && conditionList.operator === "in"
                ? { label: "=", value: "0" }
                : { label: "!=", value: "1" }
          }
          return null
        })
      return null
    })
  return {
    store_id: stores,
    task_type: taskTypes,
    operator,
    storeConditionOperator,
    taskTypeConditionOperator,
  }
}

export const generateCommaSeparatedIds = (items: any[]) => items.map((item) => item.value).join(",")

// Get stores based on roles
export const getUserStoresBasedonRoles = async (roles: string[]) => {
  try {
    const userId = getUserEmail()
    const userRoleMapping = await getUserRoleMapping(userId)
    const userAccessStores = []
    if (Array.isArray(userRoleMapping) && userRoleMapping.length > 0) {
      for (let mapping of userRoleMapping) {
        const { roleName, scope } = mapping
        if (roles.includes(roleName)) {
          const scopeObject = JSON.parse(scope)
          const { stores } = scopeObject
          let storeIds = []
          if (stores === ".*") {
            storeIds = ["All"]
            return storeIds
          } else {
            storeIds = stores.split("|")
          }
          userAccessStores.push(...storeIds)
        }
      }
      return Array.from(new Set(userAccessStores))
    }
  } catch (err) {
    console.error(`getUserRoleStoreMapping: Error`, err)
  }
  return []
}
